import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTimesCircle} from '@fortawesome/pro-regular-svg-icons/faTimesCircle';

export default () => {
    const handleRefresh = () => {
        window.location.reload();
    };

    return (
        <div className="p-4" onClick={handleRefresh}>
            <div className="flex items-start">
                <div className="shrink-0 text-red-400">
                    <FontAwesomeIcon icon={faTimesCircle} size="lg"/>
                </div>
                <div className="ml-3 w-0 flex-1 pt-0.5">
                    <p className="text-sm leading-5 font-medium text-gray-900">
                        Session expired
                    </p>
                    <p className="mt-1 text-sm leading-5">
                        Please click here to login again
                    </p>
                </div>
            </div>
        </div>
    );
};
